import { RxCross2 } from "react-icons/rx";
import SideBar from "../../Pages/Shop/Components/SideBar";
import { useEffect } from "react";
import { useShop } from "../../Providers/ShopProvider";

import './Styles/MobileProductFiltersStyles.css'

const MobileProductFilters = ({ showMobileFilterPage, setShowMobileFilterPage }) => {
    const { clearProductsFilter } = useShop()

    useEffect(() => {
        if (showMobileFilterPage) {
            document.body.style.overflow = 'hidden'
        }
        return () => {
            document.body.style.overflow = 'auto'
        }
    }, [showMobileFilterPage])

    const handleClearFilters = () => {
        clearProductsFilter(true, true)
        setShowMobileFilterPage(false)
    }

    if (!showMobileFilterPage) {
        return null
    }

    return (
        <div className='full-screen-overlay'>
            {/* Nagłówek - pozostaje na górze */}
            <div className="row w-100 flex-shrink-0 mt-4 mb-2 ps-3">
                <div className="col-6">
                    <h2>Filtrowanie</h2>
                </div>
                <div className="col-6 d-flex justify-content-end align-items-center">
                    <RxCross2 size={30} color="var(--primary)" className="me-4 element-pointer" onClick={() => setShowMobileFilterPage(false)} />
                </div>
            </div>

            {/* Kontener na treść z własnym przewijaniem */}
            <div className="filter-content-scrollable w-100 ps-3 pb-3" style={{ marginBottom: '50px' }}>
                <div className="row">
                    <SideBar />
                </div>
                <div className="row d-flex feature">
                    <div className="col-6">
                        <button className="btn-app-secondary" onClick={() => handleClearFilters()}>Wyczyść filtry</button>
                    </div>
                    <div className="col-6 d-flex justify-content-end">
                        <button className="btn-app-primary" onClick={() => setShowMobileFilterPage(false)}>Zastosuj</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileProductFilters